import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";

const Grid = styled.div`
  flex: 1;
  min-height: calc(100vmin - 8px);

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: min-content 1fr min-content;
  grid-template-areas:
    "header"
    "mainScreen"
    "footer";

  ${mq("sm")} {
    grid-template-columns: 1fr minmax(min-content, 1200px) 1fr;
    grid-template-rows: max-content max-content 1fr;
    grid-template-areas:
      ". header ."
      "crosses1 mainScreen crosses2"
      ". footer .";
  }
`;

const GridLayout = ({ children }) => {
  return <Grid>{children}</Grid>;
};

export default GridLayout;
